import React, { Suspense } from 'react'

import { Route, Switch } from 'react-router-dom'

import { LayoutSplashScreen } from '_metronic'

import { DARDEBAJA_MAIN } from 'constants/codigosTransacciones'

import MainPage from './main'

export default function DarDeBajaPages() {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        <Route path={`/${DARDEBAJA_MAIN}`} component={MainPage} />
      </Switch>
    </Suspense>
  )
}
